import React from 'react';
import { Popconfirm, Input, Flex } from 'antd';
import { DeleteOutlined, EditOutlined, CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

interface City {
  key: string;
  title: string;
  country: string;
  dataIndex: string;
  similar: boolean;
  duplicate: boolean;
}

export interface CityRowProps {
  city: City;
  isEditing: boolean;
  onEdit: () => void;
  onSave: () => void;
  onCancel: () => void;
  onDelete: (key: string, title: string) => void;
  inputValue: string;
  setInputValue: React.Dispatch<React.SetStateAction<string>>;
}

const CityRow: React.FC<CityRowProps> = ({
                                           city,
                                           isEditing,
                                           onEdit,
                                           onSave,
                                           onCancel,
                                           onDelete,
                                           inputValue,
                                           setInputValue,
                                         }) => {
  const { t } = useTranslation();

  const highlightMatch = (text: string, isSimilar: boolean, duplicate: boolean) => {
    if (isSimilar || duplicate) {
      return (
        <div>
          <div style={{ color: 'red' }}>{text}</div>
        </div>
      );
    }
    return (
      <strong>{text} </strong>
    );
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      {isEditing ? (
        <>
          <Input
            allowClear
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            style={{ marginRight: 8 }}
          />
          <CheckOutlined
            onClick={onSave}
            style={{ marginLeft: 8, cursor: 'pointer', color: 'green' }}
          />
          <CloseOutlined
            onClick={onCancel}
            style={{ marginLeft: 8, cursor: 'pointer', color: 'red' }}
          />
        </>
      ) : (
        <Flex justify={'space-between'} style={{ width: '100%' }}>
          <div>
            {highlightMatch(city.title, city.similar, city.duplicate)}
          </div>
          <div>
            <EditOutlined
              onClick={onEdit}
              style={{ marginLeft: 8, cursor: 'pointer' }}
            />
            <Popconfirm
              title={t('DeleteConfirm')}
              onConfirm={() => onDelete(city.key, city.title)}
              okText={t('Yes')}
              cancelText={t('No')}>
              <DeleteOutlined style={{ marginLeft: 8, color: 'red', cursor: 'pointer' }} />
            </Popconfirm>
          </div>
        </Flex>
      )}
    </div>
  );
};

export default CityRow;